define('utils/trigo',['jquery'], function($) {
    var trigo = {};
    trigo.toDegrees = function(radians) {
        return radians * (180 / Math.PI);
    };
    trigo.toRadians = function(degrees) {
        return degrees * (Math.PI / 180);
    };

    trigo.getAngle = function(xMouse, yMouse, xEast, yEast, xOrigin, yOrigin){
        // Calcul de l'angle Est Origine Souris
        // distance origin - mouse
        var origin_mouse = Math.sqrt(Math.pow(xMouse-xOrigin, 2) + Math.pow(yMouse-yOrigin, 2));
        // distance origin - east (radius)
        var origin_east = Math.sqrt(Math.pow(xEast-xOrigin, 2) + Math.pow(yEast-yOrigin, 2));
        // distance east - mouse
        var east_mouse = Math.sqrt(Math.pow(xEast-xMouse, 2) + Math.pow(yEast-yMouse, 2));
        // Calcul angle : α=arccos((b*b+c*c−a*a) / 2bc)
        var angle = Math.acos((Math.pow(origin_east, 2) + Math.pow(origin_mouse, 2) - Math.pow(east_mouse, 2))/(2*origin_east*origin_mouse));
        // Inverte angle if x0 > xm
        if (yMouse < yOrigin){
            angle = 2*Math.PI - angle;
        }
        return angle;
    };
    
    return trigo;
});

